// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2P14O","header":"Messages_header__2fOsZ"};